/**
 * Cómo se lee y de qué color va cada concepto de factura.
 *
 * Vive aquí y no dentro de un componente porque lo usan **dos**: la barra del desglose por concepto
 * y la tabla de Comprobantes. Estaban copiados, y dos copias del mismo mapa de cinco entradas es
 * exactamente cómo empiezan a divergir.
 */
export const CONCEPT_LABEL: Record<string, string> = {
	RENT: 'Renta',
	FIRST_PAYMENT: 'Pago inicial',
	RESIDUAL: 'Residual',
	MANAGEMENT_EXPENSE: 'Gestoría',
	OTHER: 'Otro',
}

export const CONCEPT_COLOR: Record<string, string> = {
	RENT: '#3b82f6',
	FIRST_PAYMENT: '#00c781',
	RESIDUAL: '#f59e0b',
	MANAGEMENT_EXPENSE: '#a855f7',
	OTHER: '#94a3b8',
}
